const state = {
    filelist: [],
}

const mutations = {
    setFileList(state, filelist){
        state.filelist = filelist;
    }
}

const actions = {
    async fetchSpeakerDatas({ commit }, data){
        commit('setFileList', data);
    },
}

const getters = {
    filelist: state => state.filelist,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};